import React, { forwardRef } from 'react';
import { LoadingOverlay } from '@mantine/core';
import { Empty } from '@shakkerai/pro-components';

/**
 * 加载状态包裹组件，提供加载中和加载失败的遮罩，建议配合useLoadingHooks使用
 */
export const LoadingWrapper = forwardRef((props, ref) => {
  const { isLoading, isLoadSuccess, isLoadFailed, onReload, children, loadFailContent } = props;

  return (
    <div className={`relative h-full w-full`} ref={ref}>
      <div
        className={`relative h-full w-full`}
        style={{
          opacity: isLoadSuccess ? 1 : 0,
        }}
      >
        {children}
      </div>
      <LoadingOverlay
        visible={isLoading}
        loaderProps={{
          type: 'bars',
        }}
        zIndex={1000}
      />
      <LoadingOverlay
        visible={isLoadFailed}
        loaderProps={{
          type: '',
          children: (
            <Empty
              content={
                loadFailContent ? (
                  <div>{loadFailContent}</div>
                ) : (
                  <div>
                    Failed To Load,
                    <a
                      className="cursor-pointer underline text-[#1880FF]"
                      data-role="gen-history-trigger"
                      onClick={onReload}
                    >
                      Please Reload
                    </a>
                  </div>
                )
              }
            />
          ),
        }}
        zIndex={1000}
      />
    </div>
  );
});
